import { BenchmarkResults } from "../types/debuggerServiceTypes";

/**
 * Calculates the hit rate for benchmark results
 * Includes unconfident→confident and unconfident→unconfident transitions as hits/matches
 * @param results - The benchmark results object
 * @returns The hit rate as a percentage (0-100)
 */
export function calculateHitRate(results: BenchmarkResults): number {
  // Count all successful matches/hits:
  // - Previously matched now matched
  // - Previously mismatched now matched
  // - Previously unconfident now confident
  // - Previously unconfident now unconfident
  const totalHits =
    results.num_previously_matched_now_matched +
    results.num_previously_mismatched_now_matched +
    results.num_previously_unconfident_now_confident +
    results.num_previously_unconfident_now_unconfident;

  const hitRate = totalHits / results.total_messages;

  // Round to 2 decimal places
  return Math.round(hitRate * 10000) / 100;
}
